import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette, fontSizes, lineHeights, fontWeights, breakpoints,
}: Theme) => ({
  root: {
    listStyle: 'none',
    margin: 0,
    paddingLeft: 0,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
    '& svg': {
      marginRight: 12,
    },
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    width: '100%',
    color: palette.text.primary,
    textAlign: 'left',
    textDecoration: 'none',
    [breakpoints.up('md')]: {
      width: 'unset',
    },
  },
  strongText: {
    fontWeight: fontWeights.medium,
  },
  listNote: {
    display: 'block',
    color: palette.grey['700'],
    fontSize: fontSizes.xxs,
    lineHeight: lineHeights.xs,
    fontWeight: fontWeights.regular,
  },
  iconWrapper: {
    lineHeight: 0,
  },
}));
